import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { redeemMagicLink } from '../api/client';

export default function MagicLinkRedeem() {
    const { accessCode, magicToken } = useParams();
    const navigate = useNavigate();
    const [error, setError] = useState('');

    useEffect(() => {
        redeem();
    }, []);

    const redeem = async () => {
        try {
            const data = await redeemMagicLink(accessCode, magicToken);
            if (data.detail) {
                setError(data.detail);
                return;
            }

            localStorage.setItem('portal_client_id', data.client_id);
            localStorage.setItem('portal_access_code', data.access_code);
            localStorage.setItem('portal_client_name', data.client_name);
            localStorage.setItem('portal_token', data.token);

            navigate(`/portal/${accessCode}/home`);
        } catch (err) {
            setError('This link is invalid or has expired.');
        }
    };

    return (
        <div style={styles.screen}>
            <div style={styles.card}>
                <div style={styles.logo}>Transformation Companion</div>
                {error ? (
                    <>
                        <div style={styles.errorAlert}>{error}</div>
                        <p style={styles.hint}>
                            Ask your coach for a new link, or <a href={`/portal/${accessCode}`} style={styles.link}>sign in with your password</a>.
                        </p>
                    </>
                ) : (
                    <div style={styles.loadingText}>Signing you in...</div>
                )}
            </div>
        </div>
    );
}

const styles = {
    screen: { minHeight: '100vh', background: '#F8F5F0', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontFamily: "'Figtree','Segoe UI',sans-serif" },
    card: { background: 'white', borderRadius: '16px', border: '1px solid #D8E0DC', padding: '40px', width: '100%', maxWidth: '420px', boxShadow: '0 8px 32px rgba(0,0,0,0.08)', textAlign: 'center' },
    logo: { fontFamily: 'Georgia,serif', fontSize: '20px', fontWeight: '300', fontStyle: 'italic', color: '#5C7A6B', marginBottom: '24px' },
    loadingText: { fontSize: '14px', color: '#8C9E98' },
    errorAlert: { background: '#F5EAEA', color: '#B85C5C', padding: '12px 14px', borderRadius: '8px', fontSize: '13.5px' },
    hint: { fontSize: '13px', color: '#8C9E98', textAlign: 'center', marginTop: '16px', lineHeight: 1.6 },
    link: { color: '#5C7A6B', fontWeight: '500' },
};
